import { AttachmentBlockAttachmentType } from 'common/builder/blocks/blockConstants'
import { IBlockImage } from 'common/builder/blocks/blockInterfaces'
import {
  CardImageType,
  FlowChartCardImage,
} from 'common/builder/components/chart/FlowChart/types/FlowChartCardsBlock'
import { Field } from 'common/fields/entities/field'

import { PreviewConverter } from './PreviewConverter'
import { replaceFieldsInString } from './replaceFieldsInString'

export class CardImageConverter {
  /**
   * Replaces Fields in FlowChartCardImage properties in place
   */
  static replaceFieldsInCardImage(image: FlowChartCardImage, fields: Field[]): FlowChartCardImage {
    if (!image || image.type !== CardImageType.EXTERNAL) {
      return image
    }

    image.url = replaceFieldsInString(image.url, fields)
    return image
  }

  static fromIBlockImage(image: IBlockImage): FlowChartCardImage {
    if (!image || typeof image !== 'object') {
      return null
    }

    if (image?.type === AttachmentBlockAttachmentType.EXTERNAL_IMAGE) {
      return {
        type: CardImageType.EXTERNAL,
        url: image.image_url,
      }
    }

    const preview = PreviewConverter.fromIBlockImage(image)
    if (!preview) {
      return null
    }

    return {
      type: CardImageType.PREVIEW,
      preview,
    }
  }
}
